/**
 * Cleans a number value for yup schema tranformation.
 *
 * @returns undefined if the input isNaN otherwise the given number.
 */
export const yupNumberTransformer = (value: number): number | undefined => (isNaN(value) ? undefined : value)
